<template>
  <div>
    <div
      v-if="modelValue.length > 0"
      class="flex items-center gap-2 text-xs font-medium text-gray-500 dark:text-gray-400 mt-3 mb-0.5"
    >
      <span class="flex-1">Product</span>
      <span class="w-44 shrink-0">Location</span>
      <span class="w-16 shrink-0 text-center">Qty</span>
      <span class="w-8 shrink-0" />
    </div>
    <InventoryUsage
      v-for="(usage, index) in modelValue"
      :key="index"
      :usage="usage"
      :locations="locations"
      @update:usage="(val) => updateRow(index, val)"
      @remove="removeRow(index)"
    />
    <div
      class="-mx-4 -mb-4 flex items-center border-t border-gray-200 dark:border-gray-600 px-4 py-3 mt-3 gap-4"
    >
      <button
        data-cy="add-product-btn"
        type="button"
        class="shrink-0 inline-flex items-center gap-1.5 text-xs font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg px-2.5 py-1.5 disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="loading"
        @click="addRow"
      >
        <svg
          class="w-3.5 h-3.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
        Add Product
      </button>
      <span class="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">
        *Only Products Tracked in Inventory will appear listed here
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { InventoryLocation } from "@/typings/inventory";
import type { EditableUsage } from "./InventoryUsage.vue";
import InventoryUsage from "./InventoryUsage.vue";

const props = defineProps<{
  modelValue: EditableUsage[];
  locations: InventoryLocation[];
  defaultLocationId: number | null;
  loading?: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [usages: EditableUsage[]];
}>();

const addRow = () => {
  emit("update:modelValue", [
    ...props.modelValue,
    {
      part_id: null,
      part_name: "",
      inventory_location_id: props.defaultLocationId,
      quantity: 1
    }
  ]);
};

const removeRow = (index: number) => {
  const updated = [...props.modelValue];
  updated.splice(index, 1);
  emit("update:modelValue", updated);
};

const updateRow = (index: number, usage: EditableUsage) => {
  const updated = [...props.modelValue];
  updated[index] = usage;
  emit("update:modelValue", updated);
};
</script>
